<template>
  <div
    class="wrap wrap_layout request is-overwrap has-side"
    :class="{ 'show-side': showSideNav }"
  >
    <!-- Page content -->
    <div class="content container-fluid has-no-left-padding">
      <!-- タブボタン部分 -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link active">新規お届け先登録</a>
        </li>
      </ul>

      <!--タブのコンテンツ部分-->
      <div class="tab-content">
        <div class="tab-pane active">
          <div class="text-right mb20">
            <a
              href="#"
              @click.prevent="closeNewPageHandler"
              class="btn btn-primary"
              ><i class="fa fa-arrow-left" aria-hidden="true"></i>
              お届け先一覧に戻る</a
            >
          </div>
          <table
            class="table table-bordered bg-white tbl_request01 tbl_sample02"
          >
            <tbody>
              <tr>
                <th class="bg-tbl-light is-width-200">
                  お届け先名
                  <span class="text-danger">
                    ※必須
                  </span>
                </th>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': add_error.ngfg_dlCompanyNa }"
                    v-model="dlcompany_na"
                    :disabled="is_validated"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="add_error.ngfg_dlCompanyNa"
                  >
                    {{ add_error.msg_dlCompanyNa }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">お届け先支店名</th>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': add_error.ngfg_dlCompanySubNa }"
                    v-model="dlcompanysub_na"
                    :disabled="is_validated"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="add_error.ngfg_dlCompanySubNa"
                  >
                    {{ add_error.msg_dlCompanySubNa }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">
                  お届け先半角ｶﾅ
                  <span class="text-danger">
                    ※必須
                  </span>
                </th>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': add_error.ngfg_dlCompanyKanaNa }"
                    v-model="dlcompanykana_na"
                    :disabled="is_validated"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="add_error.ngfg_dlCompanyKanaNa"
                  >
                    {{ add_error.msg_dlCompanyKanaNa }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">
                  郵便番号
                  <span class="text-danger">
                    ※必須
                  </span>
                </th>
                <td>
                  <input
                    type="tel"
                    class="form-control zip ml-0 is-auto-width"
                    :class="{ 'is-invalid': add_error.ngfg_dlPostCd }"
                    maxlength="7"
                    v-model="dlpost_cd"
                    :disabled="is_validated"
                  />*数字のみ入力下さい
                  <div class="invalid-feedback" v-if="add_error.ngfg_dlPostCd">
                    {{ add_error.msg_dlPostCd }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">
                  住所
                  <span class="text-danger">
                    ※必須
                  </span>
                </th>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': add_error.ngfg_dlAddressNa }"
                    v-model="dladdress_na"
                    :disabled="is_validated"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="add_error.ngfg_dlAddressNa"
                  >
                    {{ add_error.msg_dlAddressNa }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">
                  TEL
                  <span class="text-danger">
                    ※必須
                  </span>
                </th>
                <td>
                  <input
                    type="tel"
                    class="form-control tel ml-0 is-auto-width"
                    :class="{ 'is-invalid': add_error.ngfg_dlTelNo }"
                    v-model="dltel_no"
                    :disabled="is_validated"
                  />*数字のみ入力下さい
                  <div class="invalid-feedback" v-if="add_error.ngfg_dlTelNo">
                    {{ add_error.msg_dlTelNo }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="bg-tbl-light is-width-200">FAX</th>
                <td>
                  <input
                    type="tel"
                    class="form-control tel ml-0 is-auto-width"
                    :class="{ 'is-invalid': add_error.ngfg_dlFaxNo }"
                    v-model="dlfax_no"
                    :disabled="is_validated"
                  />*数字のみ入力下さい
                  <div class="invalid-feedback" v-if="add_error.ngfg_dlFaxNo">
                    {{ add_error.msg_dlFaxNo }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="btn_edit mt20">
          <button class="btn btn-info btn-sm" @click="resetDeliveryInfoHandler">
            修正
          </button>
          <button
            class="btn btn-primary btn-sm"
            @click="checkDeliveryInfoHandler"
          >
            完了
          </button>
        </div>
        <div class="alert alert-success mt-3" v-if="is_validated">
          こちらの内容でよろしければ「新規登録」を押下してください。
        </div>
        <div class="btn-center">
          <button
            class="btn btn-request btn-lg"
            :disabled="!is_validated"
            @click="editDeliveryInfoHandler"
            v-if="is_validated"
          >
            新規登録
          </button>
        </div>
      </div>
      <!-- tab-pane -->
    </div>
  </div>
</template>

<script>
// Store
import { store as BootstrapStore } from "../../../store/Bootstrap";

export default {
  data() {
    return {
      // Add Info
      dlcompany_na: "",
      dlcompanysub_na: "",
      dlcompanykana_na: "",
      dlpost_cd: "",
      dladdress_na: "",
      dltel_no: "",
      dlfax_no: "",

      add_error: {},
      is_validated: false
    };
  },
  computed: {
    showSideNav() {
      return BootstrapStore.showSideNav;
    }
  },
  watch: {
    async dlpost_cd(newVal) {
      const address = await this.$commonHandler.getAddress(newVal);
      if (address === false) {
        return;
      }

      this.dladdress_na = address;
    }
  },
  methods: {
    resetDeliveryInfoHandler() {
      this.is_validated = false;
    },

    async checkDeliveryInfoHandler() {
      this.add_error = {};
      this.is_validated = false;

      const response = await this.postAsteria(
        "CommonAPI",
        "checkDeliveryInfo_req",
        {
          dlcompany_na: this.dlcompany_na,
          dlcompanysub_na: this.dlcompanysub_na,
          dlcompanykana_na: this.dlcompanykana_na,
          dlpost_cd: this.dlpost_cd,
          dladdress_na: this.dladdress_na,
          dltel_no: this.dltel_no,
          dlfax_no: this.dlfax_no
        }
      );

      if (response.responseData.return != 0) {
        this.add_error = response.responseData;
        return;
      }

      this.is_validated = true;
    },

    async editDeliveryInfoHandler() {
      if (!this.is_validated) {
        return;
      }

      const response = await this.postAsteria(
        "CommonAPI",
        "editDeliveryInfo_req",
        {
          dlcompany_na: this.dlcompany_na,
          dlcompanysub_na: this.dlcompanysub_na,
          dlcompanykana_na: this.dlcompanykana_na,
          dlpost_cd: this.dlpost_cd,
          dladdress_na: this.dladdress_na,
          dltel_no: this.dltel_no,
          dlfax_no: this.dlfax_no
        }
      );

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("新規お届け先登録の送信に失敗しました");
        }
        return;
      }

      // window.alert("新規お届け先登録の送信が完了しました");

      const deliveryDataList = this.getAsteriaArray(
        response.responseData,
        "deliveryData"
      );

      // 追加したお届け先コード
      const addedDeliveryCd = response.responseData.delivery_cd;

      this.$emit("added", { deliveryDataList, addedDeliveryCd });
      this.closeNewPageHandler();
    },

    closeNewPageHandler() {
      this.$emit("close");
    }
  }
};
</script>
